var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxoutlineclipboardTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,6.8c-1,0-2.8,0-2.8-2.8S9,1.2,10,1.2h4c1,0,2.8,0,2.8,2.8c0,1,0,2.8-2.8,2.8H10z M8.8,4 C8.8,5.2,9,5.2,10,5.2h4c1.2,0,1.2-0.3,1.2-1.2c0-1.2-0.3-1.2-1.2-1.2h-4C9,2.8,8.8,2.8,8.8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,22.8c-5.6,0-6.7-2.7-6.7-6.8v-6 c0-4.6,1.7-6.5,5.7-6.7c0.4,0,0.8,0.3,0.8,0.7S8.4,4.8,8,4.8C5.2,5,3.7,5.8,3.7,10v6c0,3.7,0.7,5.2,5.2,5.2h5 c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H8.9L8.9,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,15v-5c0-4.2-1.4-5.1-4.3-5.2 c-0.4,0-0.7-0.4-0.7-0.8s0.4-0.7,0.8-0.7c4.1,0.2,5.7,2.2,5.7,6.7v5c0,0.4-0.3,0.8-0.8,0.8C20.6,15.7,20.3,15.4,20.3,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,12.9c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h7c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,17c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h4.4c0.4,0,0.8,0.3,0.8,0.8S12.8,17,12.4,17H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,22.5l-1-1c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0l0.5,0.5l2.5-2.5c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1l-3,3c-0.1,0.1-0.3,0.2-0.5,0.2 C18,22.7,17.7,22.7,17.5,22.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlineclipboardTask);
export default __webpack_public_path__ + "static/media/vuesaxoutlineclipboard-task.b49f114a4233a5909a94f4d594afbd88.svg";
export { ForwardRef as ReactComponent };